module.exports = __webpack_public_path__ + "img/2.b2784070.svg";